window.newArea = window.ktgBoxAreaOfProduct;
window.qtyChangedFromQtySelector = false;
if (!customElements.get('ktg-room-area-calculator')) {
    class KtgRoomAreaCalculator extends HTMLElement {
        constructor() {
            super();
            this.init();
        }

        init(){
            this.length = this.querySelector('#ktg-room-length');
            this.width = this.querySelector('#ktg-room-width');
            this.resultsField = this.querySelector('#ktg-room-area-result');
            this.resultsDisplayField = this.querySelector('#ktg-display-room-area-result');
            this.areaCalculator = document.querySelector('ktg-area-calculator');
            this.submitButton = this.querySelector('#ktg-room-area-submit-button');
            this.resultsContainer = this.querySelector("#ktg-room-results-container");
            this.pageQtySelector = document.querySelector('#ktg-quantity-selector');
            this.pageInputQtyField = this.pageQtySelector.querySelector('.qty');
            this.accordionParent = this.closest('details').querySelector('summary');

            this.length.addEventListener('input', this.handleInputEvent.bind(this));
            this.length.addEventListener('change', this.handleInputEvent.bind(this));
            this.width.addEventListener('input', this.handleInputEvent.bind(this));
            this.width.addEventListener('change', this.handleInputEvent.bind(this));
            this.submitButton.addEventListener('click', this.handleSubmitEvent.bind(this));
        }

        handleInputEvent(event){
            const isValidLength = this.validateInput(this.length, this.length.value);
            const isValidWidth = this.validateInput(this.width, this.width.value);
            if(!isValidLength || !isValidWidth) {
                this.clearResults();
                return;
            }; 
            this.calculateRoomArea(+this.length.value, +this.width.value);
        }

        calculateRoomArea(length, width){
            const roomArea = length * width;
            if(roomArea == 0){
                this.clearResults();
                return;
            }
            const boxesCount = Math.ceil(roomArea / window.ktgBoxAreaOfProduct); 
            this.resultsField.value=boxesCount;
            this.resultsField.setAttribute('data-area', roomArea);
            this.resultsDisplayField.textContent = `${boxesCount} boxes`;
            this.resultsContainer.classList.remove('ktg-hide');
        }

        clearResults(){
            this.resultsContainer.classList.add('ktg-hide');
            this.resultsField.value = '';
            this.resultsField.setAttribute('data-area', 0);
            this.resultsDisplayField.textContent = '';
        }

        validateInput(field, value) {
            if (isNaN(value) || value.trim() === '') {
                field.value = ''; 
                return false;
            }
            return true;
        }

        handleSubmitEvent(event){
            const boxesCount = this.resultsField.value; 
            this.areaCalculator.areaField.value = this.resultsField.getAttribute('data-area');
            this.areaCalculator.areaField.dispatchEvent(new Event('change', { bubbles: true }));
            // this.pageInputQtyField.value=boxesCount;
            // this.pageQtySelector.validateQtyRules();
            this.accordionParent.dispatchEvent(new Event('click'));
            setTimeout(() => this.pageInputQtyField.focus(), 100);
        }
    }
  customElements.define('ktg-room-area-calculator', KtgRoomAreaCalculator);
}

if (!customElements.get('ktg-area-calculator')) {
    class KtgAreaCalculator extends HTMLElement {
        constructor() {
            super();
            this.init();
        }

        init(){
            this.areaField = this.querySelector('#ktg-area-field');
            this.resultsField = this.querySelector('#ktg-room-area-result');
            this.resultsDisplayField = this.querySelector('#ktg-display-room-area-result');
            this.resultsContainer = this.querySelector("#ktg-room-results-container");
            this.pageQtySelector = document.querySelector('#ktg-quantity-selector');
            this.pageInputQtyField = this.pageQtySelector.querySelector('.qty');
            this.KtgWasteConsideration = document.querySelector('ktg-waste-consideration');

            this.areaField.addEventListener('input', this.handleInputEvent.bind(this));
            this.areaField.addEventListener('change', this.handleInputEvent.bind(this));
        }

        handleInputEvent(event){
            const isValidArea = this.validateInput();
            if(!isValidArea) {
                this.clearResults(); 
                return;
            }; 
            window.qtyChangedFromQtySelector = false;
            this.calculateBoxes(+this.areaField.value);
        }

        calculateBoxes(roomArea){
            if(roomArea == 0){
                this.clearResults();
                return;
            }
            window.newArea = roomArea;
            const isChecked = this.KtgWasteConsideration.wasteConsiderationField.checked;
            if(isChecked){
                this.KtgWasteConsideration.updateRequiredArea(isChecked);
                return;
            }
            const boxesCount = Math.ceil(roomArea / window.ktgBoxAreaOfProduct); 
            this.resultsField.value=boxesCount;
            this.resultsDisplayField.textContent = `${boxesCount} boxes`;
            this.resultsContainer.classList.remove('ktg-hide');
            this.pageInputQtyField.value=boxesCount; 
            this.pageInputQtyField.dispatchEvent(new Event('change', { bubbles: true }));
            this.pageQtySelector.validateQtyRules();
        }

        clearResults(){
            this.resultsContainer.classList.add('ktg-hide');
            this.resultsField.value = '';
            this.resultsDisplayField.textContent = '';
            this.pageInputQtyField.value=1; 
            this.pageQtySelector.validateQtyRules();
            window.newArea = window.ktgBoxAreaOfProduct;
            const isChecked = this.KtgWasteConsideration.wasteConsiderationField.checked;
            isChecked && this.KtgWasteConsideration.updateRequiredArea(isChecked);
        }

        validateInput() {
            const area = this.areaField.value;
            if (isNaN(area) || area.trim() === '') {
                this.areaField.value = ''; 
                return false;
            }
            return true;
        }
    }
  customElements.define('ktg-area-calculator', KtgAreaCalculator);
}

if (!customElements.get('ktg-waste-consideration')) {
    class KtgWasteConsideration extends HTMLElement {
        constructor() {
            super();
            this.init();
        }

        init(){
            this.wasteConsiderPercentField = this.querySelector('#ktg-waste-consideration-percent');
            this.wasteConsiderationField = this.querySelector('#ktg-waste-consideration');
            this.wasteConsiderationLabel = this.querySelector('[for="ktg-waster-consideration"]');
            this.pageQtySelector = document.querySelector('#ktg-quantity-selector');
            this.pageInputQtyField = this.pageQtySelector.querySelector('.qty');
            this.KtgRoomAreaCalculator = document.querySelector('ktg-area-calculator');
            this.areaField = this.KtgRoomAreaCalculator.areaField;
            this.wasteConsideration = +this.wasteConsiderPercentField.value; 
            this.wasteConsiderationLabel.addEventListener('click', this.handleClickEvent.bind(this));
        }

        handleClickEvent(event){
            const isChecked = this.wasteConsiderationField.checked;
            this.updateRequiredArea(!isChecked);
            this.wasteConsiderationField.checked = isChecked ? false: true;
        }

        updateRequiredArea(isChecked){
            let roomArea = window.qtyChangedFromQtySelector ? `${window.newArea}` : this.areaField.value;
            const isValidArea = this.validateArea(roomArea);
            let boxesCount = +this.pageInputQtyField.value; 
            const wasteFactor = !isNaN(this.wasteConsideration) ? this.wasteConsideration : 0;
            if(isChecked){
                if(isValidArea){
                    // Calculate increased area
                    window.newArea = (roomArea * (1 + wasteFactor / 100)).toFixed(2); 
                } else {
                    // Calculate room area by multiplying number of boxes and area of each
                    roomArea = boxesCount * window.ktgBoxAreaOfProduct;  
                    // Calculate increased area
                    window.newArea = (roomArea * (1 + wasteFactor / 100)).toFixed(2);
                }
            } else {
                window.newArea = ((window.newArea * 100) / (100 + wasteFactor)).toFixed(2);
            }
            boxesCount = Math.ceil(window.newArea / window.ktgBoxAreaOfProduct); 
            this.pageInputQtyField.value = boxesCount; 
            this.pageInputQtyField.dispatchEvent(new Event('change', { bubbles: true }));
            this.pageQtySelector.validateQtyRules();
        }

        validateArea(area){
            if (isNaN(area) || area.trim() === '') {
                return false;
            }
            return +area; 
        }
    }
  customElements.define('ktg-waste-consideration', KtgWasteConsideration);
}